<template>
  <div>
    <div v-if="saved_reSendCurrentTime" class="pt-4 text-center">
      <span class="text-message">Resend OTP in </span>
      <span class="back-button">{{ saved_reSendCurrentTime }}s</span>
    </div>
    <div v-else class="text-center forgot-password pt-4" v-on:click="reSendOtp">
      Resend OTP
    </div>
  </div>
</template>

<script>
import CommonCode from "./../mixins/CommonCode";
import UserUtils from "./../mixins/UserUtils";
import { EventBus } from "../../events";

export default {
  mixins: [CommonCode, UserUtils],

  props: {
    typedata: {
      type: String,
    },
    startResendOtpInterval: {
      type: Boolean,
    },

  },

  data() {
    return {
      interval: 1,
      timerValue: 60,
      // saved_reSendCurrentTime:60
    };
  },

  methods: {
    onInterval() {
      if (this.saved_reSendCurrentTime <= 0) {
        clearInterval(this.saved_timerInterval);
      } else {
        this.timerCounter(
          parseInt(this.saved_reSendCurrentTime) - parseInt(this.interval)
        );
      }
    },

    startInterval() {
      this.timerInterval = setInterval(this.onInterval, this.interval * 1000);
      this.setTimerInterval(this.timerInterval);
      
    },

    reSendOtp() {
      this.$root.$emit("hideMessage", true);
      let properties = {
        requestData: this.fetch_data,
      };
      EventBus.$emit(
        "captureEvents",
        "accounts_resend-otp:customer_click",
        properties
      );
      this.timerCounter(this.timerValue);
       this.$emit('generateOTP');
    },

    timerCounter(value) {
      this.$store.dispatch("users/updateTime", value).then(() => {});
    },

    setTimerInterval(value) {
      this.$store.dispatch("users/updateTimeInterval", value).then(() => {});
    },
  },

  mounted() {
    this.timerCounter(this.timerValue);
    this.$emit('generateOTP');
  },
  watch:{
    startResendOtpInterval:{
      immediate: true,
      deep: true,
      handler(oldValue,newValue) {
      this.interval=1;
      if(oldValue){
        this.startInterval();
        }
      },
    },
  }
};
</script>

<style scoped>
</style>